export let OverlayType;
(function (OverlayType) {
  OverlayType["MODAL"] = "UIModal";
  OverlayType["PUBLIC_API"] = "PublicApi";
})(OverlayType || (OverlayType = {}));
export let OverlayDisplayConfigMessageType;
(function (OverlayDisplayConfigMessageType) {
  OverlayDisplayConfigMessageType["OVERLAY_OPEN_MESSAGE"] = "NAV_DISPLAY_CONFIG_OVERLAY_OPEN_MESSAGE";
  OverlayDisplayConfigMessageType["OVERLAY_CLOSE_MESSAGE"] = "NAV_DISPLAY_CONFIG_OVERLAY_CLOSE_MESSAGE";
})(OverlayDisplayConfigMessageType || (OverlayDisplayConfigMessageType = {}));